'use client';
import { LoadingScreen } from '@/components/common/LoadingScreen';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
export default function Home() {
	const router = useRouter();

	useEffect(() => {
		router.push('/for_you/curiosity');
	}, [router]);

	return (
		<div className="h-screen w-screen flex items-center justify-center">
			<LoadingScreen />
		</div>
	);
}
